<template>
  <q-card class="preview column justify-center q-pa-none" flat>
    <div class="preview-header absolute-top-left text-grey-8 zubie-font">{{ label }}</div>
    <div class="q-pa-md">
      <div class="report-preview text-right bg-white">
        <div v-if="!customLogo" class="preview-text">Platform Technology by</div>
        <div class="row justify-end items-center no-wrap">
          <div>
            <img v-if="customLogo" class="preview-logo" :src="customLogo" />
            <ZubieLogo v-else class="preview-logo--default text-black" height="38px" title="Zubie" />
          </div>
          <div v-if="!customLogo"><q-separator class="preview-separator" size="1.75px" vertical /></div>
          <div v-if="!customLogo">
            <img
              class="preview-bosch-logo"
              src="https://res.cloudinary.com/zubie/image/upload/v1765404558/apps/web/bosch_logo.png"
            />
          </div>
        </div>
      </div>
    </div>
  </q-card>
</template>

<script setup lang="ts">
import ZubieLogo from 'src/assets/zubie-logo.svg?component';

defineProps<{ label: string; customLogo?: string | null }>();
</script>

<style scoped lang="scss">
.preview {
  min-height: 105px;
  border: 1px solid $grey-3;
}

.logo-help {
  margin: 4px 0 0 12px;
}

.preview-header {
  margin: 4px 0 0 12px;
  font-size: 18px;
}

.preview-logo {
  height: 40px;
  width: 100%;
  display: block;
  object-fit: contain;
}

.preview-logo--default {
  margin-top: 1px;
  margin-right: 4px;
}

.preview-separator {
  height: 45px;
  margin-left: 12px;
  margin-right: 14px;
  background-color: #b9c0c5;
}

.preview-bosch-logo {
  height: 50px;
  width: auto;
  display: block;
  object-fit: contain;
}

.preview-text {
  margin-right: 10px;
  margin-bottom: 3px;
  font-family:
    Calibri,
    Carlito,
    'Segoe UI',
    Candara,
    'Trebuchet MS',
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Helvetica Neue',
    Arial,
    sans-serif;
  font-size: 13.5px;
}
</style>
